(function () {
  function initMissionMegaMenu(root) {
    if (!root || root.dataset.mmInit) return;
    root.dataset.mmInit = "1";

  
  if(root.dataset.customerAccounts==='true' && !document.querySelector('shopify-store')){
    const store=document.createElement('shopify-store');
    store.setAttribute('store-domain', root.dataset.storeDomain||('https://'+location.host));
    store.setAttribute('country', root.dataset.storeCountry||'US');
    store.setAttribute('language', root.dataset.storeLanguage||'en');
    store.setAttribute('hidden','');
    document.body.prepend(store);
  }

  const cfg=JSON.parse(root.querySelector('[data-mm-config]').textContent);
  const hdr=root.querySelector('[data-mm-hdr]');
  const mega=root.querySelector('[data-mm-mega]');
  const dnav=root.querySelector('[data-mm-dnav]');
  const drawer=root.querySelector('[data-mm-drawer]');
  const scrim=root.querySelector('[data-mm-scrim]');
  const burger=root.querySelector('[data-mm-burger]');
  const rail=root.querySelector('[data-mm-rail]');
  const dttl=root.querySelector('[data-mm-dttl]');
  const back=root.querySelector('[data-mm-back]');
  const p0=root.querySelector('[data-mm-p0]');
  const p1=root.querySelector('[data-mm-p1]');
  const p2=root.querySelector('[data-mm-p2]');
  const gsp=root.querySelector('[data-mm-gsp]');
  const gspin=root.querySelector('[data-mm-gspin]');
  const gscrim=root.querySelector('[data-mm-gscrim]');
  const CHEV='<svg class="mm-chev" viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  let openLi=null, openT=null, closeT=null, aimT=null, mx=0, pmx=0, l1title='Menu', gsActive=null;
  let lockedDtop=null, scrollLockY=0;

  function money(cents){
    if(cents==null) return '';
    const n=(Number(cents)/100).toFixed(2);
    return '$'+Number(n).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
  }
  function esc(t){return String(t||'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));}

  function panels(){return Array.from(mega.children).filter(function(el){return el.hasAttribute('data-panel');});}
  function closeMega(){
    clearTimeout(openT);
    mega.classList.remove('on');
    dnav.querySelectorAll('li').forEach(li=>{
      li.classList.remove('open');
      const t=li.querySelector('[data-mm-tab]');
      if(t) t.setAttribute('aria-expanded','false');
    });
    panels().forEach(p=>{p.hidden=true;p.classList.remove('is-active');});
    openLi=null;
  }
  function showPanel(li, id){
    clearTimeout(closeT);
    dnav.querySelectorAll('li').forEach(x=>{
      x.classList.remove('open');
      const t=x.querySelector('[data-mm-tab]');
      if(t) t.setAttribute('aria-expanded','false');
    });
    li.classList.add('open');
    const tab=li.querySelector('[data-mm-tab]');
    if(tab) tab.setAttribute('aria-expanded','true');
    let active=null;
    panels().forEach(p=>{
      const on=p.getAttribute('data-panel')===id;
      p.hidden=!on;
      p.classList.remove('is-active');
      if(on){
        
        void p.offsetWidth;
        p.classList.add('is-active');
        active=p;
      }
    });
    
    mega.scrollTop=0;
    mega.classList.add('on');
    openLi=li;
    bindRail(active);
  }
  function bindRail(panel){
    if(!panel) return;
    panel.querySelectorAll('.mm-ri[data-g]').forEach(btn=>{
      if(btn.dataset.bound) return;
      btn.dataset.bound='1';
      const pick=()=>{
        const gi=+btn.dataset.g;
        panel.querySelectorAll('.mm-ri[data-g]').forEach(b=>{
          const on=+b.dataset.g===gi;
          b.classList.toggle('on',on);
          b.setAttribute('aria-pressed',on?'true':'false');
        });
        panel.querySelectorAll('.mm-gpane').forEach((p,i)=>p.hidden=i!==gi);
      };
      btn.addEventListener('mouseenter',pick);
      btn.addEventListener('focus',pick);
      btn.addEventListener('click',pick);
    });
    const boatBtns=panel.querySelectorAll('[data-b]');
    if(boatBtns.length){
      const onMove=e=>{pmx=mx;mx=e.clientX;};
      if(!mega.dataset.aim){mega.dataset.aim='1';mega.addEventListener('mousemove',onMove,{passive:true});}
      boatBtns.forEach(r=>{
        if(r.dataset.bound) return;
        r.dataset.bound='1';
        const pick=()=>{
          const i=+r.dataset.b;
          boatBtns.forEach(x=>x.classList.toggle('on',+x.dataset.b===i));
          panel.querySelectorAll('[data-boat-pane]').forEach(p=>p.hidden=+p.getAttribute('data-boat-pane')!==i);
        };
        r.addEventListener('mouseenter',()=>{clearTimeout(aimT);aimT=setTimeout(pick, mx-pmx>0?300:40);});
        r.addEventListener('mouseleave',()=>clearTimeout(aimT));
        r.addEventListener('focus',pick);
        r.addEventListener('click',pick);
      });
    }
  }
  dnav.querySelectorAll('[data-mm-tab]').forEach(tab=>{
    const li=tab.closest('li');
    const id=tab.getAttribute('data-panel');
    const open=()=>{gsClose();showPanel(li,id);};
    tab.addEventListener('mouseenter',()=>{clearTimeout(openT);if(openLi===li)return;openT=setTimeout(open,openLi?120:220);});
    tab.addEventListener('mouseleave',()=>clearTimeout(openT));
    tab.addEventListener('focus',open);
    tab.addEventListener('click',e=>{if(openLi!==li){e.preventDefault();clearTimeout(openT);open();}});
  });
  hdr.addEventListener('mouseleave',()=>{clearTimeout(openT);closeT=setTimeout(closeMega,220);});
  mega.addEventListener('mouseenter',()=>clearTimeout(closeT));
  root.querySelectorAll('[data-mm-openboat]').forEach(btn=>{
    btn.addEventListener('click',()=>{
      const boatTab=dnav.querySelector('[data-panel="boats"]');
      if(window.innerWidth>=1024 && boatTab){ showPanel(boatTab.closest('li'),'boats'); }
      else { openDrawer(); openMobileCat('boats'); }
    });
  });

  const hwrap=root.querySelector('[data-mm-help]');
  const hlink=root.querySelector('[data-mm-help-link]');
  if(hwrap&&hlink){
    let ht=null;
    const open=()=>{clearTimeout(ht);closeMega();gsClose();hwrap.classList.add('on');hlink.setAttribute('aria-expanded','true');};
    const close=()=>{clearTimeout(ht);hwrap.classList.remove('on');hlink.setAttribute('aria-expanded','false');};
    hwrap.addEventListener('mouseenter',()=>{clearTimeout(ht);ht=setTimeout(open,80);});
    hwrap.addEventListener('mouseleave',()=>{clearTimeout(ht);ht=setTimeout(close,180);});
    hlink.addEventListener('click',e=>{if(window.innerWidth<1024)return;e.preventDefault();hwrap.classList.contains('on')?close():open();});
    hwrap.addEventListener('focusin',open);
    hwrap.addEventListener('focusout',e=>{if(!hwrap.contains(e.relatedTarget))close();});
    document.addEventListener('pointerdown',e=>{if(!hwrap.contains(e.target))close();});
  }

  function lockScroll(){
    scrollLockY=window.scrollY||window.pageYOffset||0;
    document.body.style.top=(-scrollLockY)+'px';
    document.body.classList.add('mm-lock','menu-open');
  }
  function unlockScroll(){
    document.body.classList.remove('mm-lock','menu-open');
    document.body.style.top='';
    window.scrollTo(0, scrollLockY);
  }
  function placeDrawer(){
    if(drawer.classList.contains('on') && lockedDtop!=null){
      drawer.style.setProperty('--dtop', lockedDtop+'px');
      drawer.style.setProperty('--mm-dtop', lockedDtop+'px');
      return;
    }
    const top=Math.max(0,Math.round(hdr.getBoundingClientRect().bottom));
    drawer.style.setProperty('--dtop', top+'px');
    drawer.style.setProperty('--mm-dtop', top+'px');
  }
  function go(depth,title){
    if(depth===1) l1title=title;
    rail.dataset.depth=depth;
    if(depth===0){ dttl.textContent=title||'Menu'; back.hidden=true; }
    else{
      back.hidden=false;
      const crumb=depth===2?title:l1title;
      dttl.innerHTML='<span class="mm-bkl">'+(depth===2?esc(l1title):'Menu')+'</span><span class="mm-crumb"><span>'+esc(crumb)+'</span></span>';
    }
    drawer.classList.toggle('deep',depth>0);
    [p0,p1,p2][depth].scrollTop=0;
  }
  function openDrawer(){
    gsClose();
    lockScroll();
    lockedDtop=Math.round(hdr.offsetHeight)||60;
    drawer.style.setProperty('--dtop', lockedDtop+'px');
    drawer.style.setProperty('--mm-dtop', lockedDtop+'px');
    renderRecent();
    drawer.classList.add('on');
    scrim.classList.add('on');
    burger.classList.add('on');
    burger.setAttribute('aria-expanded','true');
    burger.setAttribute('aria-label','Close menu');
    drawer.setAttribute('aria-modal','true');
  }
  function closeDrawer(){
    if(!drawer.classList.contains('on'))return;
    drawer.classList.remove('on');
    scrim.classList.remove('on');
    lockedDtop=null;
    unlockScroll();
    burger.classList.remove('on');
    burger.setAttribute('aria-expanded','false');
    burger.setAttribute('aria-label','Open menu');
    drawer.setAttribute('aria-modal','false');
    go(0,'Menu');
    burger.focus();
  }
  function openMobileCat(id){
    p1.querySelectorAll('[data-mcat]').forEach(el=>el.hidden=el.getAttribute('data-mcat')!==id);
    const titleEl=root.querySelector('[data-mm-cat="'+id+'"] b');
    let title='Menu';
    if(id==='boats') title='Shop by Boat';
    else if(id==='help') title='Help';
    else if(titleEl) title=titleEl.childNodes[0].textContent.trim();
    go(1,title);
  }
  function openMobileBoat(i){
    p2.querySelectorAll('[data-mboat]').forEach(el=>el.hidden=+el.getAttribute('data-mboat')!==i);
    const row=p1.querySelector('[data-mm-boat="'+i+'"] b');
    go(2, row?row.childNodes[0].textContent.trim():'Boat');
  }
  burger.addEventListener('click',()=>drawer.classList.contains('on')?closeDrawer():openDrawer());
  root.querySelector('[data-mm-close]').addEventListener('click',closeDrawer);
  scrim.addEventListener('click',closeDrawer);
  back.addEventListener('click',()=>{const d=+rail.dataset.depth; if(d===2) go(1,l1title); else go(0,'Menu');});
  root.querySelector('[data-mm-msearch]').addEventListener('click',()=>{openDrawer();setTimeout(()=>root.querySelector('[data-mm-mq]').focus(),350);});
  p0.querySelectorAll('[data-mm-cat]').forEach(btn=>btn.addEventListener('click',()=>openMobileCat(btn.getAttribute('data-mm-cat'))));
  p1.addEventListener('click',e=>{
    const boat=e.target.closest('[data-mm-boat]');
    if(boat) openMobileBoat(+boat.getAttribute('data-mm-boat'));
    if(e.target.closest('[data-mm-openboat]')) openMobileCat('boats');
  });
  const mhelp=root.querySelector('[data-mm-mhelp]');
  if(mhelp) mhelp.addEventListener('click',e=>{e.preventDefault();openMobileCat('help');});
  window.addEventListener('resize',()=>{if(drawer.classList.contains('on'))placeDrawer(); if(gsp.classList.contains('on'))gsPlace();});
  if(window.visualViewport){
    window.visualViewport.addEventListener('resize',()=>{if(drawer.classList.contains('on'))placeDrawer();});
    window.visualViewport.addEventListener('scroll',()=>{if(drawer.classList.contains('on'))placeDrawer();});
  }
  document.addEventListener('keydown',e=>{
    if(e.key==='Escape'){closeDrawer();closeMega();gsClose();}
    if(e.key==='Tab'&&drawer.classList.contains('on')){
      const f=[burger,...drawer.querySelectorAll('a[href],button:not([hidden]),input')].filter(x=>x.offsetParent!==null);
      if(!f.length)return;
      const first=f[0],last=f[f.length-1];
      if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
      else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
    }
  });

  async function fetchProduct(handle){
    try{const r=await fetch('/products/'+encodeURIComponent(handle)+'.js'); if(!r.ok)return null; return r.json();}catch(e){return null;}
  }
  function tileHTML(p){
    if(!p) return '';
    const img=(p.featured_image||(p.images&&p.images[0])||'');
    return '<a class="mm-tile" href="/products/'+esc(p.handle)+'"><span class="mm-im">'+(img?'<img src="'+esc(img)+'" alt="" width="200" height="200" loading="lazy">':'')+'</span><b>'+esc(p.title)+'</b><span class="mm-pr">'+esc(money(p.price))+'</span></a>';
  }
  async function renderRecent(){
    const wrap=root.querySelector('[data-mm-rvwrap]');
    if(!wrap) return;
    let handles=[];
    try{handles=JSON.parse(localStorage.getItem(cfg.recentKey)||'[]')||[];}catch(e){}
    const useRecent=handles.length>=(cfg.recentMin||2);
    const list=useRecent?handles.slice(0,6):(cfg.bestSellerHandles||'').split(/[,\s]+/).filter(Boolean).slice(0,6);
    if(!list.length){wrap.innerHTML='';return;}
    const prods=(await Promise.all(list.map(fetchProduct))).filter(Boolean);
    wrap.innerHTML='<div class="mm-kick">'+(useRecent?'Recently viewed':'Best sellers')+'</div><div class="mm-hrail">'+prods.map(tileHTML).join('')+'</div>';
  }

  function gsPlace(){
    const bar=window.innerWidth>=1024?root.querySelector('.mm-topnav'):hdr;
    const b=bar.getBoundingClientRect().bottom;
    gsp.style.top=b+'px'; gscrim.style.top=b+'px';
  }
  function shortcutMatches(q){
    if(!q) return cfg.shortcuts||[];
    const w=q.toLowerCase().split(/\s+/).filter(Boolean);
    return (cfg.shortcuts||[]).filter(s=>{
      const hay=((s.label||'')+' '+(s.keywords||'')).toLowerCase();
      return w.every(x=>hay.includes(x));
    });
  }
  function productCard(p){
    const img=p.image||p.featured_image||'';
    const url=p.url||('/products/'+p.handle);
    let price='';
    if(typeof p.price==='number') price=money(p.price);
    else if(p.price) price=String(p.price);
    return '<a class="mm-tile" href="'+esc(url)+'"><span class="mm-im">'+(img?'<img src="'+esc(img)+'" alt="" loading="lazy">':'')+'</span><b>'+esc(p.title)+'</b><span class="mm-pr">'+esc(price)+'</span></a>';
  }
  async function gsRender(q){
    q=(q||'').trim();
    const jumps=shortcutMatches(q);
    let products=[];
    let head=q?'':'Best sellers';
    if(q){
      try{
        const r=await fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=10',{headers:{'Accept':'application/json'}});
        if(r.ok){
          const data=await r.json();
          products=(data.resources&&data.resources.results&&data.resources.results.products)||[];
          head=products.length?(products.length+' product'+(products.length===1?'':'s')):'';
        }
      }catch(e){}
    }else{
      const handles=(cfg.bestSellerHandles||'').split(/[,\s]+/).filter(Boolean).slice(0,5);
      products=(await Promise.all(handles.map(fetchProduct))).filter(Boolean).map(p=>({title:p.title,handle:p.handle,url:'/products/'+p.handle,image:p.featured_image,price:p.price}));
    }
    const ql=q.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g,'\\$&');
    const hl=t=>q?esc(t).replace(new RegExp('('+ql+')','ig'),'<mark>$1</mark>'):esc(t);
    let left='<div><div class="mm-kick">'+(q?'Categories':'Jump to')+'</div><ul class="mm-jump">';
    if(q) left+='<li><a class="mm-all" href="'+esc(cfg.searchUrl)+'?q='+encodeURIComponent(q)+'"><span>See all results for “'+esc(q)+'”</span></a></li>';
    left+=jumps.map(j=>'<li><a href="'+esc(j.url)+'"><span>'+hl(j.label)+'</span></a></li>').join('')+'</ul></div>';
    let right='<div>';
    if(products.length) right+='<div class="mm-kick">'+esc(head)+'</div><div class="mm-tiles">'+products.map(productCard).join('')+'</div>';
    else right+='<p class="mm-none">Nothing matched “'+esc(q)+'”. Try fender, mat or line.</p>';
    gspin.innerHTML=left+right+'</div>';
  }
  function gsOpen(input){
    closeMega(); gsActive=input; gsPlace(); gsRender(input.value);
    gsp.classList.add('on'); gscrim.classList.add('on'); input.setAttribute('aria-expanded','true');
  }
  function gsClose(){
    if(!gsp.classList.contains('on')) return;
    gsp.classList.remove('on'); gscrim.classList.remove('on');
    if(gsActive) gsActive.setAttribute('aria-expanded','false');
    gsActive=null;
  }
  root.querySelectorAll('[data-mm-search]').forEach(inp=>{
    inp.addEventListener('focus',()=>gsOpen(inp));
    inp.addEventListener('input',()=>{if(!gsp.classList.contains('on'))gsOpen(inp);gsRender(inp.value);});
    inp.addEventListener('keydown',e=>{if(e.key==='Escape'){gsClose();inp.blur();}});
  });
  gscrim.addEventListener('click',gsClose);
  document.addEventListener('pointerdown',e=>{if(gsp.classList.contains('on')&&!e.target.closest('.mm-gs, [data-mm-gsp]'))gsClose();});

  const mq=root.querySelector('[data-mm-mq]');
  let mqTimer=null;
  mq.addEventListener('focus',()=>{
    if(!drawer.classList.contains('on')) return;
    placeDrawer();
    const y=scrollLockY;
    requestAnimationFrame(function(){
      placeDrawer();
      window.scrollTo(0, y);
    });
  });
  mq.addEventListener('input',()=>{
    clearTimeout(mqTimer);
    placeDrawer();
    const q=mq.value.trim();
    if(!q){
      const res=p0.querySelector('[data-mm-search-res]');
      if(res) res.remove();
      p0.querySelectorAll('[data-mm-cat], .mm-msep, [data-mm-rvwrap]').forEach(el=>el.hidden=false);
      go(0,'Menu');
      return;
    }
    mqTimer=setTimeout(async()=>{
      p0.querySelectorAll('[data-mm-cat], .mm-msep, [data-mm-rvwrap]').forEach(el=>el.hidden=true);
      let box=p0.querySelector('[data-mm-search-res]');
      if(!box){box=document.createElement('div');box.setAttribute('data-mm-search-res','');p0.prepend(box);}
      const jumps=shortcutMatches(q);
      let products=[];
      try{
        const r=await fetch('/search/suggest.json?q='+encodeURIComponent(q)+'&resources[type]=product&resources[limit]=12',{headers:{'Accept':'application/json'}});
        if(r.ok){const data=await r.json();products=(data.resources&&data.resources.results&&data.resources.results.products)||[];}
      }catch(e){}
      let h='<a class="mm-row" href="'+esc(cfg.searchUrl)+'?q='+encodeURIComponent(q)+'"><b>See all results for “'+esc(q)+'”</b>'+CHEV+'</a>';
      if(jumps.length) h+='<div class="mm-kick">Categories</div>'+jumps.map(j=>'<a class="mm-row" href="'+esc(j.url)+'"><b>'+esc(j.label)+'</b>'+CHEV+'</a>').join('');
      h+=products.length?'<div class="mm-kick">'+products.length+' products</div><div class="mm-tiles">'+products.map(productCard).join('')+'</div>':'<div class="mm-kick">Nothing matched. Try fender, mat or line.</div>';
      box.innerHTML=h;
      go(0,'Search');
      placeDrawer();
    },180);
  });
  }

  function boot(scope) {
    (scope || document).querySelectorAll("[data-mm-root]").forEach(initMissionMegaMenu);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) {
    boot(e.target);
  });
})();
